export default __webpack_public_path__ + "static/media/backArrow.79f41f82.svg";